// 30-second TOTP countdown hook. State ticks at 1Hz — the ring uses
// CSS transitions to interpolate, so we don't need finer granularity.

import { useEffect, useState } from "react";

export const TOTP_PERIOD = 30;

export function useTotpClock() {
  const [secondsLeft, setSecondsLeft] = useState(
    TOTP_PERIOD - (Math.floor(Date.now() / 1000) % TOTP_PERIOD),
  );
  useEffect(() => {
    const i = setInterval(() => {
      setSecondsLeft(TOTP_PERIOD - (Math.floor(Date.now() / 1000) % TOTP_PERIOD));
    }, 1000);
    return () => clearInterval(i);
  }, []);
  return secondsLeft;
}
